const normalizeId = (id) => (id === undefined || id === null ? "" : String(id));

export const isSameId = (first, second) => {
    const a = normalizeId(first);
    const b = normalizeId(second);
    return Boolean(a && b && a === b);
};

export const getActiveCompanyUserById = (companyUsers = [], id) => {
    if (!id || !Array.isArray(companyUsers)) return null;

    return companyUsers.find((user) => {
        if (!user || user.isDelete === true) return false;
        return [user.userId, user._id, user.id, user.requestId].some((candidate) => isSameId(candidate, id));
    }) || null;
};

export const getCompanyUserLoginId = (companyUser) => {
    return companyUser?.userId || companyUser?.id || companyUser?._id || null;
};

export const getTaskAssigneeIds = (task = {}) => {
    if (Array.isArray(task?.AssigneeUserId)) return task.AssigneeUserId.filter(Boolean);
    return task?.AssigneeUserId ? [task.AssigneeUserId] : [];
};

export const getApprovalIdForAssignee = (assigneeId, companyUsers = []) => {
    const assignee = getActiveCompanyUserById(companyUsers, assigneeId);
    if (!assignee?.managerId) return null;

    const approval = getActiveCompanyUserById(companyUsers, assignee.managerId);
    return getCompanyUserLoginId(approval);
};

export const getApprovalIdForTask = (task = {}, companyUsers = []) => {
    const [assigneeId] = getTaskAssigneeIds(task);
    return getApprovalIdForAssignee(assigneeId, companyUsers);
};

export const isTaskAssignee = (task = {}, userId) => {
    return getTaskAssigneeIds(task).some((assigneeId) => isSameId(assigneeId, userId));
};

export const isTaskApprovalUser = (task = {}, userId, companyUsers = []) => {
    return isSameId(getApprovalIdForTask(task, companyUsers), userId);
};

export const canUserAccessKpiTask = (task = {}, userId, companyUsers = []) => {
    return isTaskAssignee(task, userId) || isTaskApprovalUser(task, userId, companyUsers);
};

export const canUserEditKpiTask = (task = {}, userId, companyUsers = []) => {
    if (!task?.isKpi) return true;
    return canUserAccessKpiTask(task, userId, companyUsers);
};
